/**
 * IA-R9 — Incident Engine host chrome (core) vs Workspace (UI shell).
 * AI stage hints visible on every spine step.
 */
import { escapeHtml } from "./dom.js";
import { INCIDENT_WORKSPACE_SPINE } from "./incident-workspace-chrome.js";

/** @type {Readonly<Record<string, string>>} */
const AI_STAGE_HINT = Object.freeze({
  observation: "What the Watch can see",
  assessment: "Risk · why",
  recommendation: "Suggested next step",
  decision: "Tonight's next step · waiting",
  execution: "Who goes",
  evidence: "Ask for more proof",
  timeline: "What already happened",
});

/**
 * @param {{
 *   activeId?: string,
 *   incidentId?: string,
 *   title?: string,
 *   modelUsed?: string,
 * }} [opts]
 */
export function incidentEngineHostHtml(opts = {}) {
  const active = String(opts.activeId || "decision").trim().toLowerCase();
  const title = String(opts.title || "Tonight's plan").trim();
  const id = String(opts.incidentId || "").trim();
  const modelUsed = String(opts.modelUsed || "").trim();
  const pills = INCIDENT_WORKSPACE_SPINE.map((s) => {
    const on = s.id === active;
    const hint = AI_STAGE_HINT[s.id] || "";
    return `<span class="croc-ie-spine__step${on ? " is-active" : ""}"${on ? ' aria-current="step"' : ""} title="${escapeHtml(hint)}">
      <span class="croc-ie-spine__label">${escapeHtml(s.label)}</span>
      <span class="muted croc-ie-spine__ai">${escapeHtml(hint)}</span>
    </span>`;
  }).join("");
  return `
  <header class="croc-ie-host glass-panel glass-panel--inset" data-incident-engine="1" data-ie-id="${escapeHtml(id)}">
    <div class="croc-ie-host__head">
      <p class="croc-ie-host__eyebrow">Tonight's plan</p>
      <h3 class="croc-ie-host__title">${escapeHtml(title)}</h3>
      <p class="muted croc-ie-host__lede">The Watch explains · you Continue or Hold${
        modelUsed ? ` · ${escapeHtml(modelUsed)}` : ""
      }</p>
    </div>
    <nav class="croc-ie-spine" aria-label="Tonight's plan">${pills}</nav>
  </header>`;
}
